module.exports = __webpack_public_path__ + "img/2-2-5.f2f73532.png";